import { createAsyncThunk } from '@reduxjs/toolkit';

import { College, handleAskLubavApiCall } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { ENVIRONMENT_URL, LUBAV_API_URL } from '@backrs_ui/grow-ui/src/settings';
import { getBackrsToken } from '@backrs_ui/grow-ui/src/utils/tokenHelpers';

import { AskLubavUniversityBadge, setActiveAskLubavUniversityBadge } from './college';

export const searchForCollegeById = createAsyncThunk(
  'college/searchForCollegeById',
  async (params: { id: string }, { rejectWithValue }) => {
    const accessToken = getBackrsToken();

    if (!accessToken) {
      return rejectWithValue('No access token found');
    }

    try {
      // Fetch the college by ID
      const url = new URL(`${ENVIRONMENT_URL}/colleges/${params.id}`);

      const response = await fetch(url.toString(), {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const college = (await response.json()) as College;

      return college;
    } catch (error) {
      return rejectWithValue(`Failed to fetch college with error: ${error}`);
    }
  },
);

export const sendCollegeAskLubavPrompt = createAsyncThunk(
  'college/sendCollegeAskLubavPrompt',
  async (
    params: {
      askLubavBadge: AskLubavUniversityBadge;
      collegeId: College['id'];
      user_id: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    const accessToken = getBackrsToken();

    if (!accessToken) {
      return rejectWithValue('No access token found');
    }

    if (!LUBAV_API_URL) {
      return rejectWithValue('No LUBAV API URL found');
    }

    try {
      const url_key = params.askLubavBadge.endpoint;

      const payload = {
        college_id: params.collegeId,
        user_id: params.user_id,
      };

      const chunks: string[] = [];

      const response = await handleAskLubavApiCall({
        url_key: url_key,
        apiUrl: LUBAV_API_URL,
        inputData: payload,
        userId: 1,
        getToken: getBackrsToken,
        askLubavResponseAccumulator: (chunk) => {
          // add the new chunk to array
          chunks.push(chunk);

          dispatch(
            setActiveAskLubavUniversityBadge({
              ...params.askLubavBadge,
              response: chunks.join(''),
              isLoading: false,
            }),
          );
        },
      });

      // once we've finished streaming, return the final response (which shouldn't be any different from the response action)
      return response?.response || chunks.join('');
    } catch (error) {
      console.error('Failed to call Lubav college prompt with error: ', error);

      return appStrings.modules.chatBox.overloadErr;
    }
  },
);
